export const COMPANY = {
  TUTORABC_SHOP: {
    BRAND_NAME: 'TutorABC Shop',
    COMPANY_NAME: {
      DEFAULT: 'Company_Name_Default_Tutorabcshop',
      EN_US: 'TutorABC Shop Limited',
    },
  },
  TUTORABC_GLOBAL: {
    BRAND_NAME: 'TutorABC Global',
    COMPANY_NAME: {
      DEFAULT: 'Company_Name_Default_TutorabcGlobal',
      EN_US: 'TutorABC Global Limited',
    },
  },
}
